import React from 'react';
import PropTypes from 'prop-types';
import { withStyles, Button } from '@material-ui/core';
import { store } from '../../../../../store';
import { useTranslation } from 'react-i18next';
import { CONSTANTS } from '../../../../../constants/constants';

const styles = theme => ({
  buttonGoBack: {
    color: '#fff',
    borderColor: '#fff',
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.6em'
    }
  },
  buttonCreateFlow: {
    color: '#fff',
    borderColor: '#fff',
    marginRight: '20px',
    [theme.breakpoints.down('md')]: {
      marginRight: '15px'
    },
    [theme.breakpoints.down('sm')]: {
      marginRight: '0px',
      fontSize: '0.6em'
    }

  },
  containerButtons: {
    flexGrow: 1,
    textAlign: 'right'
  }
});

const ButtonsToolbar = (props) => {
  const { classes, goBack, push } = props;
  const { t } = useTranslation();
  const showButtons = ['/template/view', '/template/edit', '/document/flow', '/document/view', '/file/flow'];
  const locationPath = props.location.pathname;
  const showButtonCreateFlow = locationPath.includes(showButtons[3]);
  const documentId = locationPath.split('/').pop();
  const storeDocument = store.getState().documents.documents;
  const document = storeDocument ? storeDocument.find(element => element.id === documentId) : '';

  const createNewFlow = () => {
    push(`/document/flow/${documentId}`);
  };

  const goToBack = () => {
    goBack();
  };
  for (const path of showButtons) {
    if (locationPath.includes(path)) {
      return (
        <div className={classes.containerButtons}>
          { showButtonCreateFlow && document && document.status === CONSTANTS.DOCUMENT.STATUS.INIT &&
            <Button variant='outlined' className={classes.buttonCreateFlow} onClick={() => createNewFlow()}>{t('buttonsToolbar:createFlow')}</Button>
          }
          <Button variant='outlined' className={classes.buttonGoBack} onClick={goToBack}>{t('buttonsToolbar:goBack')}</Button>
        </div>
      );
    }
  }
  return null;
};

ButtonsToolbar.propTypes = {
  classes: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  goBack: PropTypes.func.isRequired,
  push: PropTypes.func.isRequired
};

export default withStyles(styles, { withTheme: true })(ButtonsToolbar);
